import { html, el } from '../html.js';
import { screen } from '../shell.js';
import { api } from '../api.js';
import { photoCount } from '../lib/format.js';

const entry = p => el(html`<article class="entry">
  <a href="/places/${p.id}">
    ${p.coverPhotoId ? html`<img src="/api/photos/${p.coverPhotoId}/thumb" alt="" width="800" height="1000">` : html`<div class="no-photo">No photos yet</div>`}
    <div class="scrim">
      <h2>${p.name}</h2>
      <p class="byline meta">${p.addedBy}, ${photoCount(p.photoCount)}</p>
      ${p.description ? html`<p class="note">${p.description}</p>` : ''}
    </div>
  </a>
</article>`);

export async function feedView() {
  const first = await api('GET', '/api/places');
  const s = screen({ tab: 'Feed', className: 'feed-screen' });
  if (!first.places.length) {
    s.body.append(el(html`<div class="empty">
      <p>No places yet. Add the first one.</p>
      <a class="primary" href="/add">Add place</a>
    </div>`));
    return s.el;
  }
  const list = el(html`<div class="feed"></div>`);
  const more = el(html`<button class="secondary more" type="button">Show more</button>`);
  let before; // the id of the last place shown: the next page starts after it
  const show = ({ places, more: hasMore }) => {
    list.append(...places.map(entry));
    before = places.at(-1)?.id ?? before;
    more.hidden = !hasMore;
  };
  more.addEventListener('click', async () => {
    more.disabled = true;
    try {
      show(await api('GET', `/api/places?before=${before}`));
    } catch (x) {
      s.status(x.message);
    }
    more.disabled = false;
  });
  show(first);
  s.body.append(list, more);
  return s.el;
}
